export const URL = {
    HOME: '/',
    KNOWLEDGE: '/knowledge',
    FAQ: '/faq',
    CONTACT: '/contact',
    COURSES: '/courses',
    COMPANY: '/company/summary',
    SERVICE: '/service',
    CLUB: '/club',
    CORPORATE: '/corporate',
    VALUATION: '/valuation',
    HISTORY: '/company/history',
    STAFF: '/company/staff',
    RECRUIT: '/company/recruit',
    PERIODIC_MAIL: '/periodic_mail',
    PRIVACY: '/privacy',
    SITEMAP: '/sitemap',
    ABOUT_PERSONAL_INFORMATION: '/about_personal_information',
    SITEPOLICY: '/sitepolicy',
    OPEN_DATA: '/open-data',
    OPEN_DATA_MEMBERSHIP_PRICES_JSON: '/open-data/membership_prices.json',
    OPEN_DATA_MEMBERSHIP_PRICES_CSV: '/open-data/membership_prices.csv',
    MEMBER_VOICES: '/member_voices',
    COURSE_INTERVIEWS: '/course_interviews',
    RECRUITMENT_TAIHEIYO_CLUB: '/recruitment/taiheiyo-club',
    INFO_GOLF: '/info/golf',
    INFO_NEWS: '/info/news',
    INFO_STAFF_BLOG: '/info/staff_blogs',
    INFO_FEATURED_STAFF_BLOG: '/info/featured_staff_blogs',
    LP_FILE:
        'https://juchi-web-active-storage-production.s3.ap-northeast-1.amazonaws.com/download_documents/for_corporate.png',
    INFORMATION_DISCLOSURE_REQUEST_FORM:
        'https://juchi-web-active-storage-production.s3.ap-northeast-1.amazonaws.com/download_documents/%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E9%96%8B%E7%A4%BA%E8%AB%8B%E6%B1%82%E6%9B%B8.pdf',
    PERSONAL_INFORMATION_CORRECTION_REQUEST_FORM:
        'https://juchi-web-active-storage-production.s3.ap-northeast-1.amazonaws.com/download_documents/%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E8%A8%82%E6%AD%A3%E7%AD%89%E8%AB%8B%E6%B1%82%E6%9B%B8.pdf',
    PROXY_FORM:
        'https://juchi-web-active-storage-production.s3.ap-northeast-1.amazonaws.com/download_documents/%E5%A7%94%E4%BB%BB%E7%8A%B6.pdf',
};

// コース個別ページの各CTAから問い合わせフォームへ遷移するURLを組み立てる。
// utm_source / utm_medium で「どの位置のCTAからCVに至ったか」をGA4で計測できるようにする。
export const CtaPosition = {
    FirstView: 'cta_first_view',
    Middle: 'cta_middle',
    Bottom: 'cta_bottom',
} as const;
export type CtaPositionType = (typeof CtaPosition)[keyof typeof CtaPosition];

// `URLSearchParams`はSSR実行環境（mini_racer）に存在しないグローバルのため使わない。
// クエリはcourse_id/utm_source/utm_mediumの3つだけで固定なので、手組みでもCSR/SSRの出力は完全に一致する
const buildQueryString = (params: [key: string, value: string | undefined][]): string =>
    params
        .filter((p): p is [string, string] => p[1] !== undefined)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

export const buildCourseContactUrl = (courseId: string | undefined, position: CtaPositionType): string => {
    const query = buildQueryString([
        ['course_id', courseId],
        ['utm_source', 'course_detail'],
        ['utm_medium', position],
    ]);
    return `${URL.CONTACT}?${query}`;
};

// 特設LP（募集ページ）の各CTAから問い合わせフォームへ遷移するURLを組み立てる。
// lpSource には LP ごとの utm_source（例: 'taiheiyo_lp'）を渡し、LP別×CTA位置別にGA4で計測する。
export const buildLpContactUrl = (lpSource: string, position: CtaPositionType, courseId?: string): string => {
    const query = buildQueryString([
        ['course_id', courseId],
        ['utm_source', lpSource],
        ['utm_medium', position],
    ]);
    return `${URL.CONTACT}?${query}`;
};
